import type CompositeVerdictRepository from "@/core/compliance/repositories/CompositeVerdictRepository";
import type { CompositeVerdict } from "@/core/compliance/entities/CompositeVerdict";
import { RepositoryResult } from "@/core/shared/types/RepositoryResult";
import { HttpClient } from "../../http/HttpClient";
import { ApiResponse } from "../../api/types/ApiResponse";
import { executeRequest } from "../../http/services/executeRequest/executeRequest";
import compositeVerdictEndpoints from "../../api/compositeVerdictEndpoints/compositeVerdictEndpoints";
import type { CompositeVerdictAudit } from "@/core/compliance/entities/CompositeVerdictAudit";
import {
  type CompositeVerdictAuditDto,
  type CompositeVerdictDto,
  mapVerdictAuditDtoToEntity,
  mapVerdictDtoToEntity,
} from "./mappers";

export default class CompositeVerdictRepositoryBackend implements CompositeVerdictRepository {
  constructor(private readonly httpClient: HttpClient) {}

  getVerdict(businessKey: string): Promise<RepositoryResult<CompositeVerdict>> {
    return executeRequest(
      () =>
        this.httpClient.get<ApiResponse<CompositeVerdictDto>>({
          url: compositeVerdictEndpoints.verdict(businessKey),
          withAuth: true,
        }),
      (data) => mapVerdictDtoToEntity(data),
    );
  }

  getAuditHistory(businessKey: string): Promise<RepositoryResult<CompositeVerdictAudit[]>> {
    return executeRequest(
      () =>
        this.httpClient.get<ApiResponse<CompositeVerdictAuditDto[]>>({
          url: compositeVerdictEndpoints.audit(businessKey),
          withAuth: true,
        }),
      // Une liste vide est une réponse valable : le dossier n'a simplement jamais été évalué.
      (data) => (data ?? []).map(mapVerdictAuditDtoToEntity),
    );
  }
}
